export const curlHttp = `# bash
curl -X POST __url__ -d '{"jsonrpc":"2.0","method":"eth_blockNumber","params":[],"id":1}'`;
